import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useEmail from '../hooks/useEmail';
import { urlApi, validarCamposTransportista, obtenerCorreosPorEmpresa } from '../helpers/functionHelpers';
import { useAlert } from '../context/AlertContext';
import '../styles/ResumenReservacion.css'
import Spinner from './Spinner';
import useProveedores from '../hooks/useProveedores';
import useCrearReservacion from '../hooks/useCrearReservacion';
import useActualizarStatusProveedor from '../hooks/useActualizarStatusProveedor';
import { emailReservaCreada } from '../utils/email/emailReservaCreada';
import useEmpresaStore from "../context/empresaStore";
import FormularioTransportista from './FormularioTransportista';
import ResumenProveedor from './Clientes/ResumenProveedor';


const ResumenReservacion = () => {
  const { folio } = useParams();
  const { setEmpresaId, empresa_id } = useEmpresaStore();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombrePrv: '',
    correoPrv: '',
    telefonoPrv: '',
    compania: '',
    fechaRsv: '',
    almacen_id: '',
    numeroOC: '',
    numFac: '',
    nmInsumo: '',
    cantidad: '',
    numeroCntdr: '',
    pesoOcantidad: '',
    numeroPallets: '',
    undmdas_id: '',
    undmdas_descripcion: '',
    containers_id: '',
    containers_descripcion: '',
    conditions_id: '',
    conditions_descripcion: '',
    comentariosPrv: '',
    statuses_id: '',
    folio: '',
    empresas_id: '',
    extras: {},
  });
  const [dataTransportista, setDataTransportista] = useState({
    ...formData,
    cab_id: '',
    nameOpr: '',
    telefonoOpr: '',
    vehiculo_id: '',
    placa: '',
    numOprUdad: '',
    personalAdcnl: '',
    cometariosTrp: '',
    correoTrp: '',
    folio: '',
    companiaProveedor: ''
  });
  const { sendEmail, error } = useEmail();
  const { proveedores: dataProveedores, loading: loadingProveedores, error: errorProveedores } = useProveedores(`${urlApi}/api/proveedores/${folio}`);
  const { proveedores: dataTransportistaApi, loading: loadingTransportista } = useProveedores(`${urlApi}/api/transportista/${folio}`);
  const { crearReservacion, loadingReservacion, errorReservacion } = useCrearReservacion(`${urlApi}/api/transportistas`);
  const { actualizarStatusProveedor } = useActualizarStatusProveedor();
  const { mostrarAlerta } = useAlert();

  //función para buscar el proveedor por folio y actualizar el formData
  const cargarProveedor = (proveedorEncontrado) => {
    if (proveedorEncontrado) {
      const extras = {};
      if (proveedorEncontrado.empresa_id === 4 && proveedorEncontrado.extras.campo_nombre === 'probiomedInterna') {
      extras.probiomedInterna = proveedorEncontrado.extras.campo_valor;
    }

    if (proveedorEncontrado.empresa_id === 3 && proveedorEncontrado.extras.campo_nombre === 'materialSanfer') {
      extras.materialSanfer = proveedorEncontrado.extras.campo_valor;
    }
      setFormData({
        nombrePrv: proveedorEncontrado.nombrePrv,
        correoPrv: proveedorEncontrado.correoPrv,
        telefonoPrv: proveedorEncontrado.telefonoPrv,
        compania: proveedorEncontrado.compania,
        fechaRsv: proveedorEncontrado.fechaRsv,
        almacen_id: proveedorEncontrado.almacen_id,
        numeroOC: proveedorEncontrado.numeroOC,
        numFac: proveedorEncontrado.numFac,
        nmInsumo: proveedorEncontrado.nmInsumo,
        cantidad: proveedorEncontrado.cantidad,
        numeroCntdr: proveedorEncontrado.numeroCntdr,
        pesoOcantidad: proveedorEncontrado.pesoOcantidad,
        numeroPallets: proveedorEncontrado.numeroPallets,
        undmdas_id: proveedorEncontrado.undmdas_id,
        containers_id: proveedorEncontrado.containers_id,
        conditions_id: proveedorEncontrado.conditions_id,
        comentariosPrv: proveedorEncontrado.comentariosPrv,
        statuses_id: proveedorEncontrado.statuses_id,
        folio: proveedorEncontrado.folio,
        empresas_id: proveedorEncontrado.empresa_id,
        extras,
      });
      setDataTransportista({
        cab_id: proveedorEncontrado.id,
        folio: proveedorEncontrado.folio,
        vehiculo_id: ''
      })

    }
  };

  const proveedorEmpresaId = Array.isArray(dataProveedores)
    ? dataProveedores[0]?.empresa_id
    : dataProveedores?.empresa_id;

  const transportistaExistente = Array.isArray(dataTransportistaApi)
    ? dataTransportistaApi[0]
    : null;

  //useEffect para cargar los datos del proveedor
  useEffect(() => {
    // Manejar dataProveedores como array de múltiples OCs
    const primeraOC = Array.isArray(dataProveedores) && dataProveedores.length > 0
      ? dataProveedores[0]
      : null;

    if (primeraOC) {
      setEmpresaId(primeraOC.empresa_id);
      if (primeraOC.empresa_id === empresa_id || !empresa_id) {
        cargarProveedor(primeraOC);
      }
    }
  }, [dataProveedores, empresa_id, setEmpresaId]);

  useEffect(() => {
    if (transportistaExistente) {
      setDataTransportista((prevState) => ({
        ...prevState,
        ...transportistaExistente,
      }));
    }
  }, [transportistaExistente]);

  const handleChange = (e) => {
    setDataTransportista({
      ...dataTransportista,
      [e.target.name]: e.target.value,
    });
  };

  const setCompania = (e) => {
    e.preventDefault();
    setDataTransportista({
      ...dataTransportista,
      companiaProveedor: formData.compania,
    });
  };
  if (loadingProveedores || loadingTransportista) {
    return (
      <div className="loader-container">
        <div className="spinner-wrapper">
          <Spinner />
          <p className="loading-text">Cargando datos...</p>
        </div>
      </div>
    );
  }
  if (errorProveedores) {
    return <p>Error: {error}</p>;
  }



  const sendNotification = () => {
    const subject = `Se ha creado una nueva reservación con el folio ${formData.folio} para el sistema almacenes Sanfer`;
    const body = emailReservaCreada(formData);
    const toEmail = [
      `${formData?.correoPrv}`,
      `${dataTransportista?.correoTrp}`,
    ];

    const correos = obtenerCorreosPorEmpresa(empresa_id);


    sendEmail({
      to: toEmail.join(","),
      subject,
      html: body,
      bcc: correos.join(","),
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.statuses_id === 20) {
      mostrarAlerta('Esta cita ya tiene un transportista asignado previamente', 'error');
      return;
    }
    if (!validarCamposTransportista(dataTransportista)) {
      mostrarAlerta('Por favor, completa todos los campos', 'error');
      return;
    }
    const resultado = await crearReservacion(dataTransportista);
    if (resultado) {
      await actualizarStatusProveedor(dataTransportista.folio, 20);
      await sendNotification();
      navigate(`/reservacion/${dataTransportista.folio}`);
    } else {
      mostrarAlerta('Hubo un problema al crear la reservación', 'error');
    }
  };

  return (
    <div className="summary-container">
      <ResumenProveedor
        formData={formData}
        setFormData={setFormData}
        folio={folio}
      />
      {empresa_id && proveedorEmpresaId === empresa_id && (
        <FormularioTransportista
          dataTransportista={dataTransportista}
          setDataTransportista={setDataTransportista}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          loadingReservacion={loadingReservacion}
          errorReservacion={errorReservacion}
          setCompania={setCompania}
        />
      )}
    </div>
  );
};

export default ResumenReservacion;
